export enum TimingMode {
  Preamble,
  FirmTime,
  FlexTime,
  ShareTime,
}